<template>
  <div class="product-details-obscurator fade-obscurator" v-show="show">
    <div class="product-details-sidebar slide-left">
      <h4 style="font-size: 1.3em">Produto</h4>
      <div style="padding-top: 8px">
        <div v-for="(dado, index) in data" :key="index" class="product-detail-dado">
          <h5>{{dado.title}}</h5>
          <div v-if="dado.title != 'Imagem'">{{dado.data}}</div>
          <img v-if="dado.title == 'Imagem'" src="./../../assets/img/place_holder_image.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoneyFormat from '../../providers/MoneyFormat';
var $ = require("jquery");
export default {
  name: "product-detail",
  props: ["product", "map"],
  data() {
    return {
      show: false,
      data: [],
    };
  },
  methods: {
    showDetails() {
      $(document).ready(() => {
        $("body").css("overflow-y", "hidden");
        this.show = true;
        this.createData();
      });
    },
    createData() {
      const arr = [
        { title: "#", data: this.product.id},
        { title: "Imagem", data: this.product[this.map["Imagem 01"]]},
        { title: "Nome", data: this.product[this.map.name]},
        { title: "Preço", data: MoneyFormat(this.product[this.map.price])}
      ];
      this.data = arr;
    },
  },
  mounted() {
    $(".product-details-obscurator").click(() => {
      $(document).ready(() => {
        $("body").css("overflow-y", "auto");
        this.show = false;
        this.$emit('product-detail-dismiss');
      });
    });
  },
  watch: {
    product(val) {
      if (val) {
        this.showDetails();
      }
    },
  },
};
</script>

<style>
.product-details-obscurator {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 1;
  background: rgba(0, 0, 0, .5);
}

.product-details-sidebar {
  width: 260px;
  height: 100%;
  background: #fff;
  padding: 1em;
  overflow-y: auto;
  right: -100px;
  position: absolute;
}

.product-detail-dado {
  margin-bottom: 8px;
}

.product-detail-dado h5 {
  margin: 0;
  font-size: 1em;
}
.product-detail-dado div {
  font-size: .95em;
  color: #888
}
.product-detail-dado img {
  width: 100%;
  margin-top: 8px;
  border-radius: 8px;
  overflow: hidden
}

/** ANIMATION */
.slide-left {
	-webkit-animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
	        animation: slide-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.fade-obscurator {
	-webkit-animation: fade-obscurator 0.5s;
	        animation: fade-obscurator 0.5s;
}
@-webkit-keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-100px);
            transform: translateX(-100px);
  }
}
@keyframes slide-left {
  0% {
    -webkit-transform: translateX(0);
            transform: translateX(0);
  }
  100% {
    -webkit-transform: translateX(-100px);
            transform: translateX(-100px);
  }
}

@keyframes fade-obscurator {
  0% {
    background: rgba(0, 0, 0, 0);
  }
  100% {
    background: rgba(0, 0, 0, .5);
  }
}

</style>
